import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function ReferAFriendIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Refer A Friend</title>
      <g>
        <g clipPath="url(#clip0_643_5539)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1438 2.07186C16.8962 1.69045 15.5766 2.3921 15.1952 3.63965L1.95808 46.9363C1.57667 48.1839 2.27766 49.5057 3.5252 49.8871L3.70342 49.9416C4.95096 50.323 6.27343 49.6198 6.65484 48.3723L7.66086 45.0817L19.7639 45.3954L19.7113 47.5729C19.6795 48.8275 20.6704 49.8695 21.925 49.9014L35.5577 50.2335C36.8144 50.266 37.855 49.2723 37.8862 48.0199L37.9393 45.8639L43.8087 46.0138C44.7562 46.0397 45.6008 45.4304 45.8779 44.5241L50.2575 30.1991C50.5339 29.295 50.1744 28.3176 49.3744 27.8092L18.8859 8.36615L19.892 5.07559C20.2734 3.82805 19.5695 2.50776 18.322 2.12635L18.1438 2.07186ZM55.4772 30.1218C54.6948 29.8826 53.869 30.3217 53.6298 31.1042L49.1791 45.6617C48.9405 46.442 49.379 47.27 50.1614 47.5092L51.6763 47.9723C52.4587 48.2116 53.2874 47.7709 53.5259 46.9907L57.9766 32.4331C58.2158 31.6507 57.7745 30.8242 56.9921 30.585L55.4772 30.1218Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_643_5539">
            <rect width="60" height="60" fill="white" />
          </clipPath>
        </defs>
      </g>
    </SvgIcon>
  );
}

export default ReferAFriendIcon;
